// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var loading_icon = '<svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="loading_icon" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#03417d" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(215.934 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>';

jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');
});



// Throttle function: Input as function which needs to be throttled and delay is the time interval in milliseconds
var timerId;
var throttleFunction = function (func, delay) {
	// If setTimeout is already scheduled, no need to do anything
	if (timerId) {
		return
	}

	// Schedule a setTimeout after delay seconds
	timerId = setTimeout(function () {
		func()

		// Once setTimeout function execution is finished, timerId = undefined so that in <br>
		// the next scroll event function execution can be scheduled by the setTimeout
		timerId = undefined;
	}, delay)
}

function setCookie(c_name, value, exsecs) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate());
	exdate.setSeconds(exdate.getSeconds() + exsecs);
	var c_value = escape(value) + ((exsecs == null) ? "" : "; expires=" + exdate.toUTCString());
	document.cookie = c_name + "=" + c_value + ";path=/";
}
function getCookie(c_name) {
	var i, x, y, ARRcookies = document.cookie.split(";");
	for (i = 0; i < ARRcookies.length; i++) {
		x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
		x = x.replace(/^\s+|\s+$/g, "");
		if (x == c_name) {
			return unescape(y);
		}
	}
}





jQuery(document).ready(function() {

	var width = jQuery(window).width();




	function resiNav() {
		//jQuery( ".menu" ).before( "<figure></figure>" );
		// jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		// var parents = jQuery('.menu-item-has-children');
		// for (var i = 0; i < parents.length; i++) {
		// 	var parentTitle = parents[i].children[0].text;
		// 	var previousParentTitle = parents[i].children[1].children[0].children[0];
		// 	previousParentTitle.innerText = 'Back';
		// }


		// Build two UL columns inside the Products mega menu (first 8 items in the first UL)
		var $productsSubmenu = jQuery('#menu-primary > li.menu-item-698 > .sub-menu');
		if ($productsSubmenu.length) {
			// Avoid double wrapping if already processed
			if ($productsSubmenu.children('ul.prod_menu_col').length === 0) {
				var $allItems = $productsSubmenu.children('li');
				if ($allItems.length) {
					var $firstColItems = $allItems.slice(0, 9);
					var $secondColItems = $allItems.slice(9);

					if ($firstColItems.length) {
						$firstColItems.wrapAll('<ul class="prod_menu_col"></ul>');
					}
					if ($secondColItems.length) {
						$secondColItems.wrapAll('<ul class="prod_menu_col"></ul>');
					}
				}
			}
		}

		jQuery('#menu-primary > li > .sub-menu').prepend('<p class="menu_return">Back</p>');

		jQuery('#menu-primary > li.menu-item-698 > .sub-menu').prepend('<a href="/products/" class="menu_all_prods"><span>View </span>All Products</a>');

		jQuery('.menu > .menu-item-has-children > a').click(function (e) {
			if (jQuery(window).width() < 921) {
			 	e.preventDefault();
				jQuery(this).next('ul.sub-menu').toggleClass('open');
				jQuery('.main_nav__menu').addClass('open');

			}
			
		});

		jQuery('.menu > .menu-item-has-children > ul.sub-menu > .prod_menu_col > .menu-item-has-children').click(function (e) {

			//console.log(e.target.nodeName);
			if (e.target.nodeName === 'LI') {
				jQuery(this).toggleClass('open');
			}
		});

		jQuery('.menu_return').click(function() {
			jQuery(this).parent().toggleClass('open');
			jQuery('.main_nav__menu').removeClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	jQuery('*[data-scroll]').click(function() {
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			 scrollTop: jQuery(target).offset().top - 129
		}, 300);
	});


	jQuery('.jump_links .container a').click(function(e) {
		e.preventDefault();
		var target = jQuery(this).attr('href');
		var width = jQuery(window).width();
		if (width < 901) {
			jQuery('html, body').animate({
				scrollTop: jQuery(target).offset().top - 260
			}, 300);
		} else {
			jQuery('html, body').animate({
				scrollTop: jQuery(target).offset().top - 170
			}, 300);
		}
	});

	function toggle_head_classes() {
		//console.log(jQuery(window).scrollTop());
		if (jQuery(window).scrollTop() > 50) {
			jQuery('body').addClass('sticky');
		} else {
			jQuery('body').removeClass('sticky');
		}
	}

	toggle_head_classes(); // Run on page load so if refreshing and further down page the header will look right

	jQuery(".tabbed_sections__nav").stick_in_parent({offset_top: 120});

	jQuery('.tabbed_sections__nav__select select').change(function() {
		var target = jQuery(this).val();
		jQuery('html, body').animate({
			scrollTop: jQuery('#' + target).offset().top - 120
		}, 300);
	});

	jQuery(window).scroll(function() {
		throttleFunction(toggle_head_classes, 80);
	});

	// Remove error message form CF7 when input is clicked
	if (jQuery('.wpcf7').length > 0) {
		jQuery('.wpcf7 input, .wpcf7 teaxtarea, .wpcf7 select').click(function(){
			jQuery(this).next('.wpcf7-not-valid-tip').remove();
		});
	}

	if (WPURLS.ajaxurl) {

	}

	const banner_slider = new Swiper('.banner__mask_slider.swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		  },
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		},
	});

	
	const video_slider = new Swiper('.video_slider__list', {
		slidesPerView: 2,
		spaceBetween: 30,
		loop: true,
		autoplay: false,
		pagination: {
			el: '.video_slider .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.video_slider .swiper-button-next',
			prevEl: '.video_slider .swiper-button-prev',
		},
		breakpoints: {
			900: {
				slidesPerView: 1,
			},
		}
	});


	jQuery('.vid_item__play').click(function() {
		var video = jQuery(this).parent().find('iframe').attr('src');

		jQuery('.vid_pop__video iframe').attr('src', video);
		jQuery('.vid_pop').addClass('active');
	});

	jQuery('.vid_pop__overlay').click(function() {
		jQuery('.vid_pop__video iframe').attr('src', '');
		jQuery('.vid_pop').removeClass('active');
	});


	const stats = new Swiper('.numbers__list.swiper', {
		slidesPerView: 6,
		spaceBetween: 16,
		loop: false,
		allowTouchMove: false,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			1300: {
				slidesPerView: 5,
				allowTouchMove: true,
			},
			1080: {
				slidesPerView: 4,
			},
			900: {
				slidesPerView: 3,
			},
			650: {
				slidesPerView: 2,
			},
			500: {
				slidesPerView: 1.5,
				centeredSlides: true,
				loop: true,
				spaceBetween: 25,
				allowTouchMove: true,
			},
			
		}
	});

	const logos = new Swiper('.logos.swiper', {
		spaceBetween: 30,
		speed: 1400,
		centeredSlides: true,
		autoplay: {
			delay: 400,
			disableOnInteraction: false
		},
		loop: true,
		slidesPerView: 6,
		allowTouchMove: true,
	});

	const partnerships = new Swiper('.partnerships__swiper.swiper', {
		slidesPerView: 6,
		spaceBetween: 10,
		loop: true,
		speed: 1400,
		autoplay: {
			delay: 400,
			disableOnInteraction: false
		},
		breakpoints: {
			1300: {
				slidesPerView: 5,
			},
			1080: {
				slidesPerView: 4,
			},
			900: {
				slidesPerView: 3,
			},
			650: {
				slidesPerView: 2,
			}
		}
	});


	const testimonials = new Swiper('.testimonials__list.swiper', {
		slidesPerView: 1,
		loop: true,
		autoHeight: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		}
	});

	const products = new Swiper('.feat_products__wrap.swiper', {
		slidesPerView: 2,
		spaceBetween: 30,
		loop: false,
		allowTouchMove: false,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 1,
				allowTouchMove: true,
			}
		}
	});


	const history = new Swiper('.history__list.swiper', {
		slidesPerView: 3,
		spaceBetween: 32,
		loop: false,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			1100: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 1,
			}
		}
	});

	jQuery('.page_categories__single__trigger').click(function () {
		jQuery(this).parent().addClass('open');
	});

	jQuery('.page_categories__single__links .close').click(function () {
		jQuery(this).parent().parent().removeClass('open');
	});

	jQuery('.accordions__single__tabs').easytabs({
		updateHash: false,
	});

	jQuery('.tabbed_sections__single__tabs').easytabs({
		updateHash: false,
	});

	jQuery('.simple_banner--blog select').change(function () {
		var selected = jQuery(this).find('option:selected').val();
		window.location.href = selected;
		
	});

	jQuery('.quote_tiles__single__link__note__trigger').click(function () {
		jQuery(this).parent().toggleClass('open');
	});

	jQuery('.quote_tiles__single__link__note__content__close').click(function () {
		jQuery(this).parent().parent().removeClass('open');
	});

	jQuery('.quote_tiles__inner').isotope({
		itemSelector: '.quote_tiles__single',
		percentPosition: true,
		masonry: {
		  // use outer width of grid-sizer for columnWidth
		  columnWidth: '.grid-sizer',
		  gutter: 10
		}
	})

	jQuery('.jump_links p').click(function () {
		jQuery(this).parent().parent().toggleClass('open');
	});

	jQuery('.accordions__single__trigger').click(function () {
		jQuery(this).parent().parent().toggleClass('open');
	});

	jQuery('.jump_links select').change(function () {
		var target = jQuery(this).val();
		jQuery('html, body').animate({
			scrollTop: jQuery('#' + target).offset().top - 160
		}, 300);
	});


	document.addEventListener( 'wpcf7mailsent', function( event ) {
		console.log(event);
	}, false );

	// if ( jQuery('body').hasClass('blog') ) {
	// 	jQuery("#recent-sticky").stick_in_parent({offset_top: 40});
	// }

	// Helper function to add ordinal suffix to day numbers (1st, 2nd, 3rd, 4th, etc.)
	function getOrdinalSuffix(day) {
		var dayNum = parseInt(day, 10);
		if (isNaN(dayNum)) return day;
		
		var j = dayNum % 10;
		var k = dayNum % 100;
		
		if (j == 1 && k != 11) {
			return dayNum + 'st';
		}
		if (j == 2 && k != 12) {
			return dayNum + 'nd';
		}
		if (j == 3 && k != 13) {
			return dayNum + 'rd';
		}
		return dayNum + 'th';
	}

	jQuery('.advent__calendar__wrap').on('click', '.advent__calendar__single:not(:last-child):not([data-user-answer="correct"]):not([data-user-answer="incorrect"]):not(.advent__calendar__single--disabled)', function () {
		jQuery(this).addClass('open');
		var user_exists = getCookie('calendar_user_email');
		var user_name = getCookie('calendar_user_name');
		var user_company = getCookie('calendar_user_company');

		if (user_exists){

			var question_date = jQuery(this).data('date');
			var question_index = jQuery(this).data('index');
			var question_question = jQuery(this).data('question');
			var question_answer1 = jQuery(this).data('answer1');
			var question_answer2 = jQuery(this).data('answer2');
			var question_answer3 = jQuery(this).data('answer3');

			jQuery('.advent__modal--question input[name="question_date"]').val(question_date);
			jQuery('.advent__modal--question input[name="question_index"]').val(question_index);
			jQuery('.advent__modal--question input[name="user_email"]').val(user_exists);
			jQuery('.advent__modal--question input[name="user_name"]').val(user_name);
			jQuery('.advent__modal--question input[name="user_company"]').val(user_company);
			jQuery('.advent__modal--question .advent__modal__date').text(getOrdinalSuffix(question_date) + ' December');
			jQuery('.advent__modal--question .advent__modal__question').text(question_question);

			jQuery('.advent__modal--question .advent__modal__answer input[type="radio"]').prop('checked', false);

			jQuery('.advent__modal--question .advent__modal__answer--1 label').text(question_answer1);
			jQuery('.advent__modal--question .advent__modal__answer--2 label').text(question_answer2);
			jQuery('.advent__modal--question .advent__modal__answer--3 label').text(question_answer3);
		
			jQuery('.advent__modal--question').addClass('active');

		} else {
			jQuery('.advent__modal--login').addClass('active');
		}

	});

	jQuery('#advent__modal__form--login').submit(function (e) {
		e.preventDefault();
		var name = jQuery('input[name="name"]').val();
		var email = jQuery('input[name="email"]').val();
		var company = jQuery('input[name="company"]').val();
		setCookie('calendar_user_name', name, 2592000);
		setCookie('calendar_user_email', email, 2592000);
		setCookie('calendar_user_company', company, 2592000);
		jQuery('.advent__modal').removeClass('active');
		jQuery('.advent__calendar__single').removeClass('open');
		reload_grid();
	});

	jQuery('.advent__modal__close,.advent__modal__bg').click(function () {
		jQuery('.advent__modal').removeClass('active');
		jQuery('.advent__calendar__single').removeClass('open');
	});


	jQuery('#advent__modal__form--question').submit(function (e) {
		e.preventDefault();
		var question_index = jQuery('input[name="question_index"]').val();
		var question_date = jQuery('input[name="question_date"]').val();
		var user_email = jQuery('input[name="user_email"]').val();
		var user_name = jQuery('input[name="user_name"]').val();
		var user_company = jQuery('input[name="user_company"]').val();
		var answer = jQuery('input[name="answer"]:checked').val();

		jQuery.ajax({
			url: WPURLS.ajaxurl,
			type: 'POST',
			data: {
				action: 'advent_submit_answer',
				question_index: question_index,
				question_date: question_date,
				user_email: user_email,
				user_name: user_name,
				user_company: user_company,
				answer: answer,
			}
		}).done(function (response) {

			jQuery('.advent__calendar__wrap').html(response.data.grid);

			if (response.data.status == 'correct') {
				jQuery('.advent__modal--question').removeClass('active');
				jQuery('.advent__modal--correct').addClass('active');
			} else {
				jQuery('.advent__modal--incorrect .advent__modal__content .correct').text(response.data.correct_answer);
				jQuery('.advent__modal--question').removeClass('active');
				jQuery('.advent__modal--incorrect').addClass('active');
			}
		});
	});

	function reload_grid() {
		jQuery.ajax({
			url: WPURLS.ajaxurl,
			type: 'POST',
			data: {
				action: 'initial_load_grid',
				user_email: getCookie('calendar_user_email'),
			}
		}).done(function (response) {
			jQuery('.advent__calendar__wrap').html(response.data.grid);
			jQuery('.advent__calendar__wrap').removeClass('loading');
		});
	}


	if (jQuery('.advent__calendar__wrap').length > 0 && getCookie('calendar_user_email')) {
		reload_grid();
	} else {
		jQuery('.advent__calendar__wrap').removeClass('loading');
	}

});
